import styled, { css } from 'styled-components';

export const FlagsDropownCointainer = styled.div<{ open: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  position: absolute;
  top: 40px;
  left: 50%;
  transition: max-height 0.5s, opacity 0.2s;
  transform: translateX(-50%);
  background: #ffffff;
  border-radius: 10px;
  padding: 0 10px;
  opacity: 1;
  filter: drop-shadow(0px 2px 12px rgba(0, 0, 0, 0.2));
  ${({ open }) =>
    !open &&
    css`
      transition: max-height 0.35s, opacity 0.15s;
      max-height: 0;
      overflow: hidden;
      opacity: 0;
    `}

  & > *:nth-child(1) {
    margin-top: 10px;
  }

  & > *:last-child {
    margin-bottom: 10px;
  }
`;
